import React from "react";
import img1 from "./img1.jpeg";
import DarkModeToggler from "../darkModeToggler/DarkModeToggler";

const EshopItem = () => {
  return (
    <>
      <h1 className="mt-10 mb-8 text-4xl">Eshop Item</h1>
      <DarkModeToggler />
      <div className="rounded-xl shadow p-10">
        <div
          className={`
          flex shadow-xl border border-gray-900 border-opacity-5 p-10 rounded-xl
          hover:-rotate-2 hover:-translate-y-10 transition-all duration-300 transform
          hover:shadow-2xl dark:bg-gray-700 dark:text-gray-50
          `}
        >
          <div className="mr-10">
            <div>
              <img src={img1} className="h-32 " />
            </div>
            <div className="flex justify-center">
              <div className="cursor-pointer w-2 h-2 rounded-full bg-gray-500 mr-2" />
              <div className="cursor-pointer w-2 h-2 rounded-full bg-gray-200 mr-2" />
              <div className="cursor-pointer w-2 h-2 rounded-full bg-gray-200 mr-2" />
            </div>
          </div>
          <div className="flex flex-col">
            <div className="text-4xl font-normal text-gray-600 dark:text-gray-50">
              Minimalistic jacket from leather
            </div>
            <div className="mt-2 text-4xl font-bold text-gray-700 dark:text-gray-50">
              $ 50
            </div>
            <div className="flex mt-6">
              <div className="cursor-pointer flex items-center px-4 py-2 font-bold dark:text-gray-900 text-gray-400 mr-2 bg-gray-100 rounded-3xl">
                XS
              </div>
              <div className="cursor-pointer flex items-center px-4 py-2 font-bold dark:text-gray-900 text-gray-400 mr-2 bg-gray-100 rounded-3xl">
                S
              </div>
              <div className="cursor-pointer flex items-center px-4 py-2 font-bold text-gray-50 mr-2 bg-gray-800 rounded-3xl">
                M
              </div>
              <div className="cursor-pointer flex items-center px-4 py-2 font-bold dark:text-gray-900 text-gray-400 mr-2 bg-gray-100 rounded-3xl">
                L
              </div>
              <div className="cursor-pointer flex items-center px-4 py-2 font-bold dark:text-gray-900 text-gray-400 mr-2 bg-gray-100 rounded-3xl">
                XXL
              </div>
            </div>
            <div className="flex items-center mt-12">
              <button className="transition-colors duration-300 hover:bg-blue-600 outline-none px-16 py-4 bg-blue-700 dark:bg-blue-500 text-gray-100 rounded-full">
                Buy now
              </button>
              <button className="p-3  bg-white text-red-600 rounded-full shadow ml-6 hover:bg-gray-50 hover:shadow-lg transform duration-300 transition-all hover:-translate-y-1">
                <svg
                  height="25"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EshopItem;
